import { render } from "./LitigationCreator.vue?vue&type=template&id=632d2c89&scoped=true"
import script from "./LitigationCreator.vue?vue&type=script&lang=js"
export * from "./LitigationCreator.vue?vue&type=script&lang=js"

import "./LitigationCreator.vue?vue&type=style&index=0&id=632d2c89&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632d2c89"]])

export default __exports__